<script>
  import { createEventDispatcher, onMount } from "svelte";
  const dispatch = createEventDispatcher();
  import Ikonka from "../../UI/Icon.svelte";
  export let open;
  import { mapStore } from "../../../stores/map.store";
  const map = $mapStore.mapbox.getMap();
  import length from "@turf/length";
  import { pointTo, ulozPridanuVrstvu } from "../../map/mapbox";
  import { userStore } from "../../../stores/user.store";
  import { object_filter } from "../../../helpers/functions";
  import get from "get-value";

  let merania = [];

  map.on("load", () => {
    const u = userStore.getUser();
    if (u.mapa.stav !== undefined) {
      const filtrovane = object_filter(
        u.mapa.stav,
        (vrstva) => vrstva.typ_vrstvy !== "meranie"
      );
      for (const property in filtrovane) {
        merania.push(filtrovane[property].data);

        map.addSource(filtrovane[property].data.id, {
          type: "geojson",
          data: filtrovane[property].sourceData,
          generateId: true,
        });

        // Add styles to the map
        map.addLayer({
          id: "measure-points-" + filtrovane[property].data.id,
          type: "circle",
          source: filtrovane[property].data.id,
          paint: {
            "circle-radius": 5,
            "circle-color": [
              "case",
              ["boolean", ["feature-state", "hover"], false], // Set this to false
              "#64bdbb",
              "#000",
            ],
          },
          filter: ["in", "$type", "Point"],
        });
        map.addLayer({
          id: "measure-lines-" + filtrovane[property].data.id,
          type: "line",
          source: filtrovane[property].data.id,
          layout: {
            "line-cap": "round",
            "line-join": "round",
          },
          paint: {
            "line-color": [
              "case",
              ["boolean", ["feature-state", "hover"], false], // Set this to false
              "#64bdbb",
              "#000",
            ],
            "line-width": 2.5,
          },
          filter: ["in", "$type", "LineString"],
        });
      }
      merania = [...merania];
    }
  });

  const geojson = {
    type: "FeatureCollection",
    features: [],
  };

  // Used to draw a line between points

  function merajVzdialenost() {
    const innerIndex = merania.length
      ? merania[merania.length - 1].index + 1
      : 1;

    merania[merania.length] = {
      index: innerIndex,
      id: `meranie_${innerIndex}`,
      nazov: `Meranie ${innerIndex}`,
      vzdialenost: 0,
      napoveda: `Meranie začnite kliknutím na počiatočný bod na mape`,
      geojson: {
        type: "FeatureCollection",
        features: [],
      },
    };
    // merania = [...merania, meranie];
    const meranieIndex = merania.findIndex((m) => m.index === innerIndex);
    merania[meranieIndex].geojson.features = [];
    const linestring = {
      type: "Feature",
      geometry: {
        type: "LineString",
        coordinates: [],
      },
    };

    map.addSource(merania[meranieIndex].id, {
      type: "geojson",
      data: merania[meranieIndex].geojson,
      generateId: true,
    });

    // Add styles to the map
    map.addLayer({
      id: "measure-points-" + merania[meranieIndex].id,
      type: "circle",
      source: merania[meranieIndex].id,
      paint: {
        "circle-radius": 5,
        "circle-color": [
          "case",
          ["boolean", ["feature-state", "hover"], false], // Set this to false
          "#64bdbb",
          "#000",
        ],
      },
      filter: ["in", "$type", "Point"],
    });
    map.addLayer({
      id: "measure-lines-" + merania[meranieIndex].id,
      type: "line",
      source: merania[meranieIndex].id,
      layout: {
        "line-cap": "round",
        "line-join": "round",
      },
      paint: {
        "line-color": [
          "case",
          ["boolean", ["feature-state", "hover"], false], // Set this to false
          "#64bdbb",
          "#000",
        ],
        "line-width": 2.5,
      },
      filter: ["in", "$type", "LineString"],
    });

    map.on("click", mapOnClick);

    map.on("mousemove", mapOnMove);

    function mapOnMove(e) {
      const features = map.queryRenderedFeatures(e.point, {
        layers: ["measure-points-" + merania[meranieIndex].id],
      });
      // Change the cursor to a pointer when hovering over a point on the map.
      // Otherwise cursor is a crosshair.
      map.getCanvas().style.cursor = features.length ? "pointer" : "crosshair";
    }
    function mapOnClick(e) {
      const features = map.queryRenderedFeatures(e.point, {
        layers: ["measure-points-" + merania[meranieIndex].id],
      });

      // Remove the linestring from the group
      // so we can redraw it based on the points collection.
      if (merania[meranieIndex].geojson.features.length > 1) {
        merania[meranieIndex].geojson.features.pop();
      }

      if (merania[meranieIndex].geojson.features.length > 0) {
        merania[
          meranieIndex
        ].napoveda = `Meranie ukončíte kliknutím na posledný bod.`;
      }

      // If a feature was clicked, remove it from the map.
      if (features.length) {
        const id = features[0].properties.id;

        if (
          merania[meranieIndex].geojson.features[
            merania[meranieIndex].geojson.features.length - 1
          ].properties.id === id
        ) {
          map.off("click", mapOnClick);
          map.off("mousemove", mapOnMove);
          map.getCanvas().style.cursor = "pointer";
          merania[meranieIndex].napoveda = "";
        } else {
          merania[meranieIndex].geojson.features = merania[
            meranieIndex
          ].geojson.features.filter((point) => point.properties.id !== id);
        }
      } else {
        const point = {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [e.lngLat.lng, e.lngLat.lat],
          },
          properties: {
            id: String(new Date().getTime()),
          },
        };

        merania[meranieIndex].geojson.features.push(point);
      }

      if (merania[meranieIndex].geojson.features.length > 1) {
        linestring.geometry.coordinates = merania[
          meranieIndex
        ].geojson.features.map((point) => point.geometry.coordinates);

        merania[meranieIndex].geojson.features.push(linestring);

        // Populate the distanceContainer with total distance
        const value = document.createElement("pre");
        const distance = length(linestring);
        if (distance > 1) {
          merania[meranieIndex].vzdialenost = `${distance.toLocaleString()} km`;
        } else {
          merania[meranieIndex].vzdialenost = `${(distance * 1000).toFixed(
            0
          )} m (${distance.toLocaleString()} km)`;
        }
      }

      map
        .getSource(merania[meranieIndex].id)
        .setData(merania[meranieIndex].geojson);

      ulozPridanuVrstvu(
        merania[meranieIndex],
        merania[meranieIndex].id,
        merania[meranieIndex].geojson,
        "meranie"
      );
    }
  }

  function generateId(onlyNo = false) {
    const list = document.querySelectorAll("#merania .meranie");
    const no = list.length + 1;

    if (onlyNo) {
      return no;
    }
    return `meranie_${no}`;
  }

  /**
   * Odstranim vrstvu z mapy aj z pamate a tym padom aj z navigacneho okienka
   * @param source_id
   */
  function odstranVrstvuZMapy(ind) {
    const index = merania.findIndex((m) => m.index === ind);
    // prechadzam vsetky layery, nie sources, lebo najprv treba vymazat layer
    map.getStyle().layers.forEach(function (layer) {
      // ak ma layer spravny source, tak ho vymazem
      if (merania[index].id === layer.source) {
        map.removeLayer(layer.id);
      }
    });

    // ak existuje source ktory mam vymazat
    if (map.getSource(merania[index].id)) {
      map.removeSource(merania[index].id);

      // zmazem informaciu aj z pamate stavu uzivatela
      const u = userStore.getUser();
      let stav = get(u.mapa.stav);

      if (get(stav[merania[index].id]) !== undefined) {
        delete stav[merania[index].id];
      }

      userStore.updateUser(u);
    }
    merania.splice(index, 1);
    merania = [...merania];
  }

  function doPointTo(ind) {
    const index = merania.findIndex((m) => m.index === ind);
    let highlightedFeatures = map.querySourceFeatures(merania[index].id);
    pointTo(map, map.getSource(merania[index].id)._data);
  }

  function zvyrazni(ind, highlight = true) {
    const index = merania.findIndex((m) => m.index === ind);
    let highlightedFeatures = map.querySourceFeatures(merania[index].id);

    highlightedFeatures.forEach(function (f) {
      // For each feature, update its 'highlight' state
      map.setFeatureState(
        {
          source: merania[index].id,
          id: f.id,
        },
        {
          hover: highlight,
        }
      );
    });
  }
</script>

<!-- Tab map notes start -->
<div
  class="sidebar__tab sidebar__tab--map"
  data-tab="3"
  class:js-tab--open={open}
>
  <div
    class="sidebar__close"
    on:click|preventDefault={() => dispatch("toggleSidebarTabMeranie")}
  >
    <Ikonka kod="012" />
  </div>
  <div class="sidebar__wrapper">
    <button class="btn btn--block" on:click={merajVzdialenost}>
      Spustiť meranie
    </button>
    <!-- <button class="mapboxgl-ctrl-measure-line-tool">
        <svg
          t="1575453274789"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="4964"
          width="25"
          height="25"
          ><path
            d="M947.93351 255.639285c16.063496 0 29.06104-12.998035 29.06104-29.059849L976.99455 73.015967c0-16.062837-12.997545-29.060873-29.06104-29.060873L794.334073 43.955094c-16.034842 0-29.060017 12.998035-29.060017 29.060873L765.274056 120.750131l-94.33837 0c-2.937009-0.451278-5.928256-0.451278-8.864241 0L258.72799 120.750131 258.72799 73.015967c0-16.062837-13.027222-29.060873-29.062063-29.060873L76.067513 43.955094c-16.063496 0-29.062063 12.998035-29.062063 29.060873l0 153.563468c0 16.062837 12.998568 29.059849 29.062063 29.059849l47.737143 0 0 506.581594L76.067513 762.220878c-16.063496 0-29.062063 12.997012-29.062063 29.059849l0 153.563468c0 16.062837 12.998568 29.059849 29.062063 29.059849l153.598414 0c16.034842 0 29.062063-12.997012 29.062063-29.059849l0-47.735188 506.545043 0 0 47.735188c0 16.062837 13.026198 29.059849 29.060017 29.059849l153.599437 0c16.063496 0 29.06104-12.997012 29.06104-29.059849L976.993527 791.281751c0-16.062837-12.997545-29.059849-29.06104-29.059849l-47.737143 0L900.195344 354.582761c0.050144-0.984421 0.050144-1.970888 0-2.955308l0-95.988168L947.93351 255.639285zM823.39716 102.07684l95.473264 0 0 95.441723-95.473264 0L823.39716 102.07684zM181.928783 459.920878c1.707968-1.102101 3.328951-2.394537 4.825086-3.89061l277.168724-277.158391 132.079449 0L181.928783 592.929194 181.928783 459.920878zM105.129576 102.07684l95.473264 0 0 46.62797c-0.014327 0.367367-0.02763 0.734734-0.02763 1.106194s0.014327 0.738827 0.02763 1.106194l0 46.601364-95.473264 0L105.129576 102.07684zM229.665927 255.639285c16.034842 0 29.062063-12.998035 29.062063-29.059849l0-47.707558 123.003375 0L181.928783 378.666272 181.928783 255.639285 229.665927 255.639285zM181.928783 675.116031l496.265511-496.244154 87.079762 0 0 35.606962L217.509574 762.220878l-35.580791 0L181.928783 675.116031zM105.129576 915.784346l0-95.441723 95.473264 0 0 46.600341c-0.014327 0.367367-0.02763 0.735757-0.02763 1.106194s0.014327 0.738827 0.02763 1.106194l0 46.62797L105.129576 915.783323zM842.071217 553.748846 563.784997 832.022641c-2.10912 2.109034-3.823229 4.460592-5.148464 6.965645L426.365717 838.988286l415.7055-415.688467L842.071217 553.748846zM918.870424 915.784346l-95.473264 0 0-95.441723 95.473264 0L918.870424 915.784346zM794.334073 762.220878c-16.034842 0-29.060017 12.997012-29.060017 29.059849l0 47.706535L639.011318 838.987263l203.060922-203.051579 0 126.284171L794.334073 762.219855zM842.071217 341.111958 344.174489 838.988286l-85.446499 0 0-35.795251 547.576186-547.552727 35.76704 0L842.071217 341.111958z"
            p-id="4965"
          /></svg
        >
        Meranie plochy
      </button> -->
    <div id="merania">
      {#each merania as meranie, i}
        <div
          class="meranie"
          on:mouseenter={() => zvyrazni(meranie.index)}
          on:mouseleave={() => zvyrazni(meranie.index, false)}
        >
          <div class="header">
            <span class="title">{meranie.nazov}</span>
            <span class="tlacitka">
              <span on:click={() => doPointTo(meranie.index)}>
                <!-- JSON icon location start -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon"
                  viewBox="0 0 370.854 511.999"
                  fill="currentColor"
                >
                  <g transform="translate(-70.573)">
                    <g>
                      <path
                        d="M256,0C153.755,0,70.573,83.182,70.573,185.426c0,126.888,165.939,313.167,173,321.035a16.7,16.7,0,0,0,24.846,0c7.065-7.868,173-194.147,173-321.035C441.425,83.182,358.244,0,256,0Zm0,278.719a93.292,93.292,0,1,1,93.291-93.292A93.4,93.4,0,0,1,256,278.719Z"
                      />
                    </g>
                  </g>
                </svg>
                <!-- JSON icon location end -->
              </span>
              <span on:click={() => odstranVrstvuZMapy(meranie.index)}>
                <!-- JSON icon Close start -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon"
                  viewBox="0 0 329.27 329.263"
                >
                  <g transform="translate(0 -0.135)">
                    <path
                      d="M21.34,329.4A21.332,21.332,0,0,1,6.258,292.984L292.848,6.39a21.329,21.329,0,0,1,30.164,30.164L36.422,323.148A21.231,21.231,0,0,1,21.34,329.4Zm0,0"
                      fill="#ff8d8d"
                    />
                    <path
                      d="M307.93,329.4a21.273,21.273,0,0,1-15.082-6.25L6.258,36.554A21.329,21.329,0,0,1,36.422,6.39l286.59,286.594A21.332,21.332,0,0,1,307.93,329.4Zm0,0"
                      fill="#ff8d8d"
                    />
                  </g>
                </svg>
                <!-- JSON icon Close end -->
              </span>
            </span>
          </div>
          <div class="body">
            Vzdialenosť: <strong>{meranie.vzdialenost}</strong>
            <span class="napoveda">{meranie.napoveda}</span>
          </div>
        </div>
      {/each}
    </div>
  </div>
</div>

<!-- Tab map notes end -->
<style lang="scss">
  .sidebar__wrapper {
    & > .btn {
      margin-bottom: 40px;
    }
  }
  .meranie {
    border-bottom: 1px solid #aaa;
    padding-bottom: 10px;

    .header {
      height: auto;
      background: none;
      margin: 10px 0;
      padding: 0;
      display: flex;
      justify-content: space-between;

      &::before {
        display: none;
      }

      .title {
        font-size: 1.3em;
        font-weight: 600;
      }

      .tlacitka {
        & > span {
          cursor: pointer;
        }
      }
    }

    .body {
      margin-left: 20px;

      .napoveda {
        display: block;
        font-size: 0.8em;
        color: red;
      }
    }
  }
</style>
